module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-07.02be7492.png";